export default () => ({
  isOpenFilter: false,
  pagination: {},
  filter: {},
  rows: [],
  row: null,
  rowEdit: null,
  loading: {},
  modal: {},
});
